import { render, staticRenderFns } from "./toSort.vue?vue&type=template&id=6b340526&scoped=true&"
import script from "./toSort.vue?vue&type=script&lang=js&"
export * from "./toSort.vue?vue&type=script&lang=js&"
import style0 from "./toSort.vue?vue&type=style&index=0&id=6b340526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b340526",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/toSort.vue
// module id = null
// module chunks = 